export default "__VITE_ASSET__coj4nLVz__"